import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from '../stateless/SnackBarProvider';
import { useForgotPasswordApi } from '../../Hooks/useForgotPasswordApi';

export const useForgotPassword = () => {
  const { showMessage } = useSnackbar();
  const { createForgotPassword } = useForgotPasswordApi();
  return useMutation({
    mutationKey: ['CreateChoice'],
    mutationFn: (data: any) => createForgotPassword(data),
    onSuccess: (response: any) => {
      showMessage(response?.message || 'Loged In successfully', 'success');
    },
    onError: (error: any) => {
      showMessage(error.response?.data?.message || 'Failed to login', 'error');
    },
  });
};
